module.exports = "/components/directives/emoji-9469ec.html";